import React from 'react';
import { Button } from './ui/Button';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center justify-center py-20 px-4 overflow-hidden bg-gradient-to-b from-[#050D05] via-[#0B1A0B] to-[#0B1A0B]" data-id="element-81">
      {/* Background effects */}
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-20 mix-blend-overlay" data-id="element-82"></div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-4xl bg-[#22C55E]/5 blur-[120px] rounded-full pointer-events-none" data-id="element-83"></div>

      <div className="relative z-10 max-w-4xl mx-auto text-center flex flex-col items-center" data-id="element-84">
        {/* TITLE */}
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-85">
          <h1 className="text-6xl md:text-8xl font-black tracking-tighter text-transparent bg-clip-text bg-gradient-to-b from-white to-gray-400 mb-2 drop-shadow-lg" data-id="element-86">
            VARAMAX
          </h1>
          <div className="h-1 w-32 bg-[#FF6B00] mx-auto mb-8 rounded-full" data-id="element-87"></div>
        </motion.div>

        {/* SUBTITLE */}
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-2xl md:text-4xl font-bold text-[#FFD700] uppercase mb-6 leading-tight max-w-3xl" data-id="element-88">
          ¿QUIERES UN CAMBIO REAL Y VISIBLE EN TU MASCULINIDAD?
        </motion.h2>

        {/* DESCRIPTION */}
        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-lg md:text-xl text-gray-300 mb-10 max-w-2xl leading-relaxed" data-id="element-89">
          <span className="font-bold text-white" data-id="element-90">VARAMAX</span> es el método
          natural que transforma tu tamaño, poder y vitalidad en menos de 5
          meses.{' '}
          <span className="text-[#22C55E] font-semibold" data-id="element-91">
            Sin pastillas, sin cirugía y sin riesgos.
          </span>
        </motion.p>

        {/* CTA */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.6
      }} className="w-full max-w-md" data-id="element-92">
          <Button fullWidth size="xl" className="mb-4 text-xl md:text-2xl shadow-[#FF6B00]/20 shadow-2xl" href="https://tododigitalizado.site/cart/add?id=43131978317958&quantity=1" data-id="element-93">
            ORDENA HOY MISMO, ¡SIN RIESGO!
          </Button>

          <div className="flex items-center justify-center gap-4 text-xs md:text-sm text-gray-400" data-id="element-94">
            <span className="flex items-center gap-1" data-id="element-95">
              <Lock size={14} data-id="element-96" /> Pago Seguro
            </span>
            <span className="flex items-center gap-1" data-id="element-97">
              <ShieldCheck size={14} data-id="element-98" /> Garantía 30 Días
            </span>
            <span className="flex items-center gap-1" data-id="element-99">
              <CreditCard size={14} data-id="element-100" /> Envío Discreto
            </span>
          </div>
        </motion.div>

        {/* PRODUCT IMAGE CENTRADA VISUALMENTE */}
        <motion.div initial={{
        opacity: 0,
        y: 50
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} className="mt-12 flex justify-center w-full" data-id="element-101">
          <div className="relative flex justify-center items-center w-full max-w-md" data-id="element-102">
            <div className="absolute inset-0 bg-[#FF6B00]/20 blur-3xl rounded-full -z-10" data-id="element-103"></div>

            <img src="https://cdn.magicpatterns.com/uploads/2PDzbTRSrxwjkmxs1Qs7rB/bd44924e-min.png" alt="Varamax Product" className="block w-full object-contain drop-shadow-2xl" style={{
            transform: 'translateX(-16px)'
          }} data-id="element-104" />
          </div>
        </motion.div>
      </div>
    </section>;
}